import styled from 'styled-components';
import { Modal } from 'antd';
import { ImageBackgroundConfirm } from '@nxsys/assets/images';

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    background-image: url(${ImageBackgroundConfirm});
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: 215px;
    padding: 16px 24px;
  }
  .ant-modal-close-x {
    font-size: 12px;
  }
  .ant-modal-body {
    padding: 0;
    .img-icon {
      img {
        width: 48px;
        height: 48px;
      }
    }
    p {
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      a {
        font-weight: 500;
        color: ${({ theme }) => theme?.palette?.text?.secondary};
      }
    }
  }

  .modal-footer {
    width: 100%;
    padding: 8px 0;
    margin-top: 16px;
    > div {
      width: 50%;
    }
    button {
      width: 100%;
    }
  }
`;

export const StyledTitle = styled.div`
  font-size: 18px;
  line-height: 26px;
  font-weight: 600;
  margin-top: 12px;
  margin-bottom: 6px;
  color: ${({ theme }) => theme?.palette?.text?.primary};
`;

export const StyledChildren = styled.div`
  margin: 16px 0;
`;

export const WrapperIconByType = styled.div<{
  type: 'warning' | 'success' | 'error';
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: ${({ type, theme }) =>
    type === 'warning'
      ? theme.palette?.orange[8]
      : type === 'success'
        ? theme.palette?.green[8]
        : theme.palette?.red[8]};
  border-radius: 50%;
`;

export const IconContainer = styled.div<{
  type: 'warning' | 'success' | 'error';
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 5px;
  background-color: ${({ type, theme }) =>
    type === 'warning'
      ? theme.palette?.orange[7]
      : type === 'success'
        ? theme.palette?.green[9]
        : theme.palette?.red[7]};
  border-radius: 50%;
`;

export const ParagraphWithHighlight = styled.span<{
  color?: 'red' | 'green';
}>`
  color: ${({ color = 'green', theme }) =>
    color === 'red' ? theme.palette.red[7] : theme.palette.secondary.main};
`;
